import { FilterSelect } from "components/form-elements/FilterSelect";
import React, { ReactElement } from "react";
import { getMinOptions } from "components/filters/BouwjaarFilter/getYearsOptions";

type Props = { isHomepage?: boolean };

export const FilterYearMin = ({ isHomepage }: Props): ReactElement => {
    const currentYear = new Date().getFullYear();

    return (
        <FilterSelect
            fieldName="minimumbouwjaar"
            label="Bouwjaar v.a."
            isMulti={false}
            options={[{ displayName: "Alle" }, ...getMinOptions(currentYear)]}
            ariaLabel="Bouwjaar vanaf"
            isHomepage={isHomepage}
        />
    );
};
